module.exports = __webpack_public_path__ + "img/logo_xinhangdao.9fde710a.png";